import { render, staticRenderFns } from "./record-info.vue?vue&type=template&id=daedf2ca&scoped=true&"
import script from "./record-info.vue?vue&type=script&lang=js&"
export * from "./record-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daedf2ca",
  null
  
)

export default component.exports